if (!customElements.get('minha-moto')) {
  const LEVELS = ['marca', 'cilindrada', 'modelo', 'ano'];
  const collator = new Intl.Collator('pt-BR', { numeric: true });

  customElements.define(
    'minha-moto',
    class MinhaMoto extends HTMLElement {
      connectedCallback() {
        this.selects = [...this.querySelectorAll('select[data-level]')];
        this.tipo = this.querySelector('select[data-tipo]');
        this.button = this.querySelector('button[type="submit"]');
        this.status = this.querySelector('[role="status"]');

        const details = this.closest('details');
        const onToggle = () => {
          if (details.open && !this.loading) this.loading = this.load();
        };
        details.addEventListener('toggle', onToggle);
        onToggle(); // deferred script: the bar may have been opened before this ran
        this.selects.forEach((select, index) => select.addEventListener('change', () => this.fill(index + 1)));
        // An empty product_type param must not reach the URL, so the name only exists when a type is chosen.
        this.tipo.addEventListener('change', () => {
          this.tipo.name = this.tipo.value ? 'filter.p.product_type' : '';
        });
      }

      async fetchPage(page) {
        const response = await fetch(`${this.dataset.url}&page=${page}`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const script = html.querySelector('script[type="application/json"]');
        return { pages: Number(script.dataset.pages), ...JSON.parse(script.textContent) };
      }

      async load() {
        this.status.textContent = 'Carregando motos…';
        try {
          const first = await this.fetchPage(1);
          const rest = await Promise.all(
            Array.from({ length: first.pages - 1 }, (_, index) => this.fetchPage(index + 2))
          );
          this.motos = first.motos.concat(...rest.map((page) => page.motos));
          first.tipos
            .filter(Boolean)
            .sort(collator.compare)
            .forEach((tipo) => this.tipo.add(new Option(tipo, tipo)));
          this.tipo.disabled = false;
          this.status.textContent = this.motos.length ? '' : 'Nenhuma moto cadastrada ainda.';
          this.fill(0);
        } catch (error) {
          console.error(error);
          this.loading = null;
          this.status.textContent = 'Não foi possível carregar as motos. Feche e abra de novo.';
        }
      }

      // Rebuilds the select at `level` from the choices above it and resets every select below it.
      fill(level) {
        this.selects.slice(level).forEach((select) => {
          select.length = 1;
          select.disabled = true;
        });
        this.button.disabled = !this.selects[LEVELS.length - 1].value;

        const select = this.selects[level];
        const chosen = this.selects.slice(0, level).map((parent) => parent.value);
        if (!select || chosen.includes('')) return;

        const key = LEVELS[level];
        const options = new Map();
        this.motos
          .filter((moto) => chosen.every((value, index) => String(moto[LEVELS[index]]) === value))
          .forEach((moto) => options.set(String(moto[key]), key === 'ano' ? moto.id : String(moto[key])));

        const labels = [...options.keys()].sort(collator.compare);
        if (key === 'ano') labels.reverse();
        labels.forEach((label) => select.add(new Option(label, options.get(label))));
        select.disabled = false;
      }
    }
  );
}
